document.addEventListener('DOMContentLoaded', function() {
    const tabItems = document.querySelectorAll('.benefit-list-content-btn');
    const tabContents = document.querySelectorAll('.benefit-desc');

    tabItems.forEach((item) => {
        item.addEventListener('click', () => {
            tabItems.forEach((tabItem) => {
                tabItem.classList.remove('active-tab');
            });
            item.classList.add('active-tab');

            const tabValue = item.getAttribute('data-value');
            tabContents.forEach((content) => {
                content.style.display = 'none';
            });

            const activeContent = document.querySelector(`.benefit-desc.${tabValue}`);
            activeContent.style.display = 'flex';
        });
    });

    tabItems[0].click();
});
